module.exports = __webpack_public_path__ + "static/img/图层 21.0eadad85.png";